import getCsrfToken from './getCsrfToken';

/**
 * Submits a POST form to /logout/ with CSRF token and redirect location.
 */
export const submitLogoutForm = (nextLocation?: string, ref?: string): void => {
  const resolvedNextLocation = nextLocation ?? window.location.pathname + window.location.search;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `/logout/${ref ? `?ref=${encodeURIComponent(ref)}` : ''}`;

  const csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = 'csrfmiddlewaretoken';
  csrfInput.value = getCsrfToken() || '';
  form.appendChild(csrfInput);

  const nextInput = document.createElement('input');
  nextInput.type = 'hidden';
  nextInput.name = 'next';
  nextInput.value = resolvedNextLocation;
  form.appendChild(nextInput);

  document.body.appendChild(form);
  form.submit();
};
